import { createIcon } from "@chakra-ui/react";

export const ContestIcon = createIcon({
  displayName: "ContestIcon",
  viewBox: "0 0 25 24",
  defaultProps: {
    width: "24px",
    height: "24px",
  },
  path: (
    <>
      <g clipPath="url(#clip0_9708_1130)">
        <path
          d="M19.5 5H17.5V4C17.5 3.45 17.05 3 16.5 3H8.5C7.95 3 7.5 3.45 7.5 4V5H5.5C4.4 5 3.5 5.9 3.5 7V8C3.5 10.55 5.42 12.63 7.89 12.94C8.52 14.44 9.87 15.57 11.5 15.9V19H8.5C7.95 19 7.5 19.45 7.5 20C7.5 20.55 7.95 21 8.5 21H16.5C17.05 21 17.5 20.55 17.5 20C17.5 19.45 17.05 19 16.5 19H13.5V15.9C15.13 15.57 16.48 14.44 17.11 12.94C19.58 12.63 21.5 10.55 21.5 8V7C21.5 5.9 20.6 5 19.5 5ZM5.5 8V7H7.5V10.82C6.34 10.4 5.5 9.3 5.5 8ZM19.5 8C19.5 9.3 18.66 10.4 17.5 10.82V7H19.5V8Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_9708_1130">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </>
  ),
});
